import { Formik } from 'formik';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyProfile, resetCompanyForm, updateCompanyProfile } from '../../../redux/actions';
import { isDefault, isSuccess } from '../../../redux/stateTools';
import { checkFieldsAreDiff } from '../../../utilities/object';
import { companyFormSchema } from '../../../validation';
import AutoSave from './AutoSave';
import Control from '../../../components/form/Control';
import text from '../../../text';
import FormSection from '../../../components/containers/FormSection';
var CompanyForm = function() {
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return state.profileReducer;
    }), companyProfile = _useSelector.companyProfile, updateCompanyProfileState = _useSelector.updateCompanyProfileState;
    var handleSubmit = function(values, actions) {
        var diffFields = checkFieldsAreDiff(companyProfile, values);
        if (Object.entries(diffFields).some(Boolean)) {
            dispatch(updateCompanyProfile(values));
            actions.resetForm({
                values: values,
                touched: diffFields
            });
        }
    };
    useEffect(function() {
        if (isEmpty(companyProfile)) {
            dispatch(getCompanyProfile());
        }
    }, []);
    return !isEmpty(companyProfile) && /*#__PURE__*/ React.createElement(FormSection, {
        title: text('companyDetails')
    }, /*#__PURE__*/ React.createElement(Formik, {
        validationSchema: companyFormSchema,
        initialValues: companyProfile,
        onSubmit: handleSubmit
    }, function(param) {
        var company = param.values, handleBlur = param.handleBlur, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors;
        var handleChangeWithReset = function(newValues) {
            if (!isDefault(updateCompanyProfileState)) {
                dispatch(resetCompanyForm());
            }
            handleChange(newValues);
        };
        var isFormTouched = touched && Object.values(touched).some(Boolean);
        var _company_name;
        return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.name && isSuccess(updateCompanyProfileState),
            isFailed: isFormTouched && errors.name,
            as: "input",
            type: "text",
            name: "name",
            value: (_company_name = company.name) !== null && _company_name !== void 0 ? _company_name : '',
            label: text('company'),
            onBlur: handleBlur,
            onChange: handleChangeWithReset,
            validationError: errors.name
        }))), /*#__PURE__*/ React.createElement(AutoSave, {
            isValidForm: isValid
        }));
    }));
};
export default CompanyForm;
